import React from 'react'
import { CustomCard } from '../../../../components'

function CardsResultadoImportacao({ qteDeliveries, qteIdentifiers, weight, qteSkus }) {
  // Vars
  const items = [
    { title: 'Qte de Entregas', value: qteDeliveries },
    { title: 'Qte de Identificadores', value: qteIdentifiers },
    { title: 'Peso Total', value: weight },
    { title: 'Qte Skus', value: qteSkus },
  ]

  const valueStyle = {
    fontSize: '1.2rem',
    color: '#14B0BF',
    fontWeight: 600,
  }
  // Hooks

  // Events

  // Helpers

  // Render
  return (
    <div className="p-grid">
      {items.map(i => (
        <div className="p-col-3" key={i.title}>
          <CustomCard valueStyle={valueStyle} title={i.title}>
            {i.value.toLocaleString()}
          </CustomCard>
        </div>
      ))}
    </div>
  )
}

export default CardsResultadoImportacao
